export default {
  initiateWorkflow: {
    method: "post",
    url: "/workflow-engine/v1/initiate-workflow/:id",
  },
  triggerWorflow: {
    method: "post",
    url: "/workflow-engine/v1/trigger-workflow/:id",
  },
  getWorkflowStatus: {
    method: "get",
    url: "/workflow-engine/v1/workflow/:workflow_instance_id/status",
  },
  getWorkflowList: {
    method: "get",
    url: "/workflow-engine/v1/workflows",
  },
  getWorkflowDetail: {
    method: "get",
    url: "/workflow-engine/v2/workflows/:id",
  },
  updateTaskStatus: {
    method: "put",
    url: "/workflow-engine/v1/workflow/:workflow_instance_id/tasks/:workflow_task_id",
  },
  createWorkflow: {
    method: "post",
    url: "/workflow-engine/v1/workflow",
  },
  updateWorkflowById: {
    method: "put",
    url: "/workflow-engine/v1/workflows/:id",
  },

  getTasks: {
    method: "get",
    url: "/workflow-engine/v1/tasks",
  },
  getTasksById: {
    method: "get",
    url: "/workflow-engine/v1/tasks/:id",
  },
  getTasksVersionByCode: {
    method: "get",
    url: "/workflow-engine/v1/tasks/:code/versions",
  },
  createTask: {
    method: "post",
    url: "/workflow-engine/v1/task",
  },
  editTask: {
    method: "put",
    url: "/workflow-engine/v1/tasks/:id",
  },
  getTaskList: {
    method: "get",
    url: "/workflow-engine/v1/tasks/list",
  },
  setTaskAssociate: {
    method: "post",
    url: "workflow-engine/v1/tasks/:id/associations",
  },
  updateTaskAssociate: {
    method: "put",
    url: "workflow-engine/v1/tasks/:id/associations/:associateId",
  },
  deleteTaskAssociate: {
    method: "delete",
    url: "workflow-engine/v1/tasks/:id/associations/:associateId",
  },

  getOutcomesList: {
    method: "get",
    url: "/workflow-engine/v1/outcomes/list",
  },
};
